import React from 'react';
import classNames from 'classnames';
import { MarkerLine } from 'lib/lucky-x-icons';
import { useAppDispatch } from 'store/hooks';
import { useToggle } from 'ahooks';
import AddPrpject from '../Add';
import { setCurOperateProject } from 'store/features/projectDetailSlice';
import { useWeb3Modal } from '@/components/Web3Modal';
import { useUserInfo } from 'lib/user';

interface IReportProps {
  largeIcon?: boolean;
  project: any;
}

const Report: React.FC<IReportProps> = ({ largeIcon, project }) => {
  const dispatch = useAppDispatch();
  const [openProject, { toggle, set }] = useToggle(false);
  const { toggleWeb3Modal } = useWeb3Modal();
  const { isLogin } = useUserInfo();

  return (
    <>
      <div
        onClick={() => {
          if (!isLogin) {
            toggleWeb3Modal();
          } else {
            set(true);
            dispatch(setCurOperateProject(project?.id));
          }
        }}
        className={classNames(
          ' group relative flex cursor-pointer items-center justify-center rounded-full',
          {
            'h-8 w-8  bg-neutral-100 opacity-50 backdrop-blur hover:bg-neutral-400 hover:opacity-100':
              !largeIcon,
            'h-10 w-10 border border-neutral-600 hover:border-neutral-100 ':
              largeIcon,
          }
        )}
      >
        <MarkerLine
          size={!largeIcon ? 20 : 24}
          className="text-neutral-400 group-hover:text-neutral-100"
        />
        <div className="-left-15 absolute -bottom-14 z-20  hidden w-[162px] rounded-lg border-2 border-neutral-700 bg-neutral-800 px-2 py-3 text-left text-sm font-normal  text-neutral-200 lg:group-hover:block">
          Report incorrect data
        </div>
      </div>
      <AddPrpject
        open={openProject}
        onClose={() => {
          set(false);
          dispatch(setCurOperateProject(0));
        }}
        data={project}
      />
    </>
  );
};

export default Report;
